import { render, staticRenderFns } from "./RiskConferenceSafety.vue?vue&type=template&id=ddc5d254&scoped=true&"
import script from "./RiskConferenceSafety.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc5d254",
  null
  
)

export default component.exports